import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from '../../../Link';
import { isModalUrl, isUrlInternal } from '../../utils';
import { WebStoryLink } from '../WebStoryLink';
export var InlineLink = function (_a) {
  var children = _a.children,
    href = _a.href;
  if (!href) return null;
  if (isModalUrl(href)) {
    return _jsx(WebStoryLink, {
      url: href,
      children: children
    });
  }
  return _jsx(Link, {
    role: "primary",
    href: href,
    target: isUrlInternal(href) ? '_self' : '_blank',
    children: children
  });
};